import { ActionStatus } from 'core/design/ActionStatus';
import { ThunkAction } from 'redux-thunk';
import { SIGN_IN_PROCESS_HANDLE } from 'redux/constants/auth';
import { RootState } from 'redux/reducers';
import { SignInProcessInfo, SignInProcessStep } from 'redux/types/internalTypes';
import { PayloadAction } from '../../../types/actionTypes';
import { buildActionType } from '../../service/buildActionType';

export const nextSignInProcessStep =
    (step: SignInProcessStep): ThunkAction<{}, RootState, {}, PayloadAction<SignInProcessInfo>> =>
    async (dispatch, getState) => {
        const signInProcessInfo = getState().signInProcessInfo.data;
        const newInfo = {
            previousSteps: [...signInProcessInfo.previousSteps, signInProcessInfo.currentStep],
            currentStep: step,
        };

        dispatch({
            type: buildActionType(SIGN_IN_PROCESS_HANDLE, ActionStatus.DONE),
            payload: newInfo,
        });
    };

export const goThroughSteps =
    (
        steps: Array<SignInProcessStep>,
        currentStep: SignInProcessStep
    ): ThunkAction<{}, RootState, {}, PayloadAction<SignInProcessInfo>> =>
    async dispatch => {
        const newInfo = {
            previousSteps: [...steps],
            currentStep: currentStep,
        };

        dispatch({
            type: buildActionType(SIGN_IN_PROCESS_HANDLE, ActionStatus.DONE),
            payload: newInfo,
        });
    };

export const resetSignInProcess =
    (): ThunkAction<{}, RootState, {}, PayloadAction<SignInProcessInfo>> => async dispatch => {
        dispatch({ type: buildActionType(SIGN_IN_PROCESS_HANDLE, ActionStatus.RESET) });
    };
